import React, { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import {
  sessionManagerApi,
  environmentOrchestratorApi,
  labManagerApi,
  apiProxyApi,
} from '../services/apiClient';

/**
 * Bridges the ZewstID auth state into all 4 axios clients. instructor-dashboard
 * uses a per-service axios instance pattern (sessionManagerApi etc.), each
 * with its own request interceptor that reads localStorage via getToken().
 * Rather than rewire the interceptors, we set `defaults.headers.common` on
 * each instance — the legacy interceptor's localStorage-based path returns
 * null during ZewstID-only sessions, so the default header survives.
 *
 * Mounted once inside AuthProvider so silent renews / sign-out flow through
 * automatically.
 */
const ApiBridge: React.FC = () => {
  const auth = useAuth();
  const accessToken = auth.user?.access_token;

  useEffect(() => {
    const clients = [sessionManagerApi, environmentOrchestratorApi, labManagerApi, apiProxyApi];
    if (accessToken) {
      for (const c of clients) {
        c.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
      }
    } else {
      for (const c of clients) {
        delete c.defaults.headers.common['Authorization'];
      }
    }
  }, [accessToken]);

  return null;
};

export default ApiBridge;
